<template>
    <div>
        <v-dialog
            v-model="dialog"
            overlay-opacity="0.7"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            class="col-xs-12 col-sm-12 pb-0 pl-0 pr-0 pt-0 dialog-about"
            max-width="437"
        >
            <!-- eslint-disable vue/no-unused-vars -->
            <template v-slot:activator="{ on }">
            <!-- eslint-enable -->
                <div @click="showDialog">
                    <slot></slot>
                </div>
            </template>

            <v-card class="w-p-32 signup-dialog-card">
                <div class="w-card-fullscreen">
                    <div class="pb-2">
                        <ButtonCloseModal
                            style="margin-bottom: 0 !important"
                            @close="closeButtonModal"
                        ></ButtonCloseModal>
                    </div>
                    <v-spacer></v-spacer>

                    <component v-if="actRegister" :is="comActivateComponent"></component>

                    <div v-else>
                        <div class="w-login-form" v-if="id && !signup && idfacebook">
                            <FacebookBtn
                                v-if="dialog"
                                @loggedIn="onLoggedIn"
                                @registry="existRegistryFacebook"
                                @registryData="registryDataFacebook"
                                app-id="366040276789345"
                                text-btn="Sign up with Facebook"
                            ></FacebookBtn>

                            <GoogleBtnV2
                                v-if="dialog"
                                @loggedIn="onLoggedIn"
                                @registry="existRegistry"
                                @registryData="registryData"
                                context="signup"
                                :client-id="googleId"
                            />

                            <div class="row">
                                <div class="col-sm-12 pb-0">
                                    <div class="separator"><span>or</span></div>
                                </div>
                            </div>
                            <v-btn
                                block
                                large
                                class="text-white"
                                @click="showSignupForm"
                                color="#ff5a5f"
                            >
                                <v-icon left>fal fa-envelope</v-icon>
                                Sign up with email
                            </v-btn>

                            <hr class="mt-8"/>

                            <div class="text-left">
                <span class="w-font-size-16"
                >Already have an account?
                  <a @click.prevent="openLoginDialog" href="/login"
                  >Log in</a
                  ></span
                >
                            </div>
                        </div>

                        <div class="w-signup-form">
                            <component
                                v-bind:is="currentComponent"
                                @activateRegistration="actReg"
                                :referal="referal"
                                :sitekey="sitekey"
                                :launchingContest="launchingContest"
                                :skip-captcha="skipCaptcha"
                                @close-dialog="closeButtonModal"
                            ></component>
                        </div>

                        <div class="w-login-form" v-if="!id">
                            <CompleteInformation
                                @loggedIn="onLoggedIn"
                                :profile="googleUser"
                                url="/login/google"
                            ></CompleteInformation>
                        </div>

                        <div class="w-login-form" v-if="!idfacebook">
                            <CompleteInformation
                                @loggedIn="onLoggedIn"
                                :profile="facebookUser"
                                url="/login/facebook"
                            ></CompleteInformation>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import '~/css/shared/vuetify/_dialog.css';
import "~/css/shared/role-selector-buttons-group.css";

import authPopupHandler from "@/shared/auth-popup-handler";
import eventBus from "@/shared/event-bus";

import ButtonCloseModal from "../input/ButtonCloseModal.vue";
import GoogleBtnV2 from "@/components/auth/input/GoogleBtnV2.vue";

export default {
    props: {
        googleId: String,
        sitekey: String,
        selector: {type: String, default: ''},
        referal: {},
        skipCaptcha: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    name: "SignupDialog",
    data: () => ({
        dialog: false,
        googleUser: null,
        id: true,
        signup: false,
        facebookUser: null,
        idfacebook: true,
        ert: true,
        actRegister: false,
        launchingContest: false,
    }),
    methods: {
        onLoggedIn() {
            window.location = '/user/dashboard';
        },
        openLoginDialog() {
            this.closeButtonModal();
            authPopupHandler.showLoginPopup();
        },
        showDialog(e) {
            this.dialog = true;
            e.preventDefault();
        },
        closeButtonModal() {
            this.signup = false;
            this.dialog = false;
        },
        showSignupForm() {
            this.signup = true;
        },
        existRegistry(val) {
            this.id = val;
        },
        registryData(val) {
            this.googleUser = val;
        },

        existRegistryFacebook(val) {
            this.idfacebook = val;
        },
        registryDataFacebook(val) {
            this.facebookUser = val;
        },
        actReg() {
            this.actRegister = true;
        },
    },
    computed: {
        currentComponent() {
            if (this.signup) {
                return () => import("./SignupForm.vue");
            }

            return null;
        },
        comActivateComponent() {
            if (this.actRegister) {
                return () => import("./SendActivateDialog.vue");
            }

            return null;
        },
    },
    components: {
        GoogleBtnV2,
        FacebookBtn: () => import("./input/FacebookBtn.vue"),
        CompleteInformation: () => import("./CompleteInformation.vue"),
        ButtonCloseModal,
    },
    created() {
        eventBus.on('openSignupDialog', () => {
            if (!this.dialog) {
                this.dialog = true;
            }
        });
    },
};
</script>

<style>
.signup-dialog-card .w-close-dialog {
    margin-bottom: 0;
}
</style>
